// Define a safe process object for the browser
if (typeof window !== 'undefined' && !window.process) {
  // Try to determine the environment from the URL
  let nodeEnv = 'development'; // Safer default for local development

  // Check if we're on a production or staging domain
  if (window.location.hostname === 'app.workinglit.com' ||
      window.location.hostname === 'workinglit.com') {
    nodeEnv = 'production';
  } else if (window.location.hostname === 'staging.workinglit.com') {
    nodeEnv = 'staging';
  }

  window.process = {
    env: {
      NODE_ENV: nodeEnv
    }
  };
}
